import { render, staticRenderFns } from "./LeafletGeoJSON.vue?vue&type=template&id=c456fff4"
import script from "./LeafletGeoJSON.vue?vue&type=script&lang=js"
export * from "./LeafletGeoJSON.vue?vue&type=script&lang=js"
import style0 from "./LeafletGeoJSON.vue?vue&type=style&index=0&id=c456fff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports